export { default as Accountant } from 'fixedassets/components/detail/AssetDetailAccountant';
export { default as Assurance } from 'fixedassets/components/detail/AssetDetailAssurance';
export { default as Bill } from 'fixedassets/components/detail/AssetDetailBill';
export { default as Buy } from 'fixedassets/components/detail/AssetDetailBuy';
export { default as CustodyVoucherModal } from 'fixedassets/components/detail/CustodyVoucherModal';
export { default as Codes } from 'fixedassets/components/detail/AssetDetailCodesLabel';
export { default as Files } from 'fixedassets/components/detail/AssetDetailFiles';
export { default as General } from 'fixedassets/components/detail/AssetDetailGeneral';
export { default as Location } from 'fixedassets/components/detail/AssetDetailLocation';
export { default as Notes } from 'fixedassets/components/detail/AssetDetailNotes';
export { default as Project } from 'fixedassets/components/detail/AssetDetailProject';
export { default as InsAndOuts } from 'fixedassets/components/detail/AssetDetailInsAndOuts';



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/index.js